import React__default from 'react';
import { classNames } from '@egds/react-core/utils';
import styles from '../styles/egds-search-experience-view-row.css';

const ViewRow = ({ children, className, adSlot = false, canvasTheme = 'primary', layout = 'fullwidth', paddedViewRow = true, maxWidth = false, }) => {
    const getClassNameList = classNames.bind(styles);
    const cssClassNames = getClassNameList('view-row', `view-row-theme-${canvasTheme}`, `view-row-layout-${layout}`, `view-row-padded-${paddedViewRow}`, !maxWidth && `view-row-adslot-${adSlot}`, className);
    return (React__default.createElement("div", { className: cssClassNames, "data-testid": "view-row" }, children));
};
ViewRow.displayName = 'ViewRow';

export { ViewRow as V };
//# sourceMappingURL=index-chunk.esm.js.map
